<template>
  <el-dialog title="备注" :visible.sync="visible" width="552px" :append-to-body="true" center>
    <el-form :model="form" ref="form" :rules="rules" class="form" size="small" label-width="96px">
      <el-form-item label="手机号备注" prop="remarks">
        <el-input v-model="form.remarks" placeholder="请输入" clearable maxlength="64" type="textarea" rows="3" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "popRemark",
  data() {
    return {
      visible: false,
      form: {
        remarks: ''
      },
      rules: {
        remarks: [
          { required: true, message: '请输入手机号备注', trigger: 'blur' }
        ]
      },

    }
  },
  created() {


  },
  methods: {
    show(value) {
      this.visible = true
      this.form.remarks = value || ''
    },
    ok() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('setRemark', this.form)
          this.visible = false
          this.form.remarks = ''
        }
      })

    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  padding-bottom: 0;
}

.form {
  padding-right: 20px;
}
</style>
